import React, { useCallback, useState } from "react";
import { Alert, Button } from "react-bootstrap";
import { NavLink, useParams } from "react-router-dom";
import { useGetMaillingRuleDocumentsQuery, useGetMaillingRuleProductsQuery, useGetMaillingRuleTemplatesQuery, useGetOneMaillingRuleQuery, usePostTestMaillingRuleMutation } from "../../../../services/api/repositories/MaillingRuleRepository";
import { IClientType } from "../../../../interfaces/api/IClientsType";

export default function MailingRuleDetailsSection() {

    const { uuid } = useParams();

    const [postTestMaillingRule] = usePostTestMaillingRuleMutation();

    const [postTestMaillingRuleResponseMessage, setPostTestMaillingRuleResponseMessage] = useState<string | null>(null);
    const [showAlert, setShowAlert] = useState(false);
    const [isTestButtonDisabled, setIsTestButtonDisabled] = useState(false);

    const { data, isLoading, isFetching } = useGetOneMaillingRuleQuery(
        { uuid: uuid || "" },
        { refetchOnMountOrArgChange: true }
    );

    const templates = useGetMaillingRuleTemplatesQuery(
        { uuid: uuid || "" },
        { refetchOnMountOrArgChange: true }
    );
    const documents = useGetMaillingRuleDocumentsQuery(
        { uuid: uuid || "" },
        { refetchOnMountOrArgChange: true }
    );
    const products = useGetMaillingRuleProductsQuery(
        { uuid: uuid || "" },
        { refetchOnMountOrArgChange: true }
    );

    let updated_at: string = "N/A";
    let status: string = "Inactif";
    let startDate: string = "-";
    let endDate: string = "-";
    let triggerName: string = "";
    let clientTypes: IClientType[] = [];

    let templateName: string = "";
    let documentsName = [];
    let productsName = [];

    if (data && data !== undefined && 'uuid' in data) {

        status = data && data?.status === "inactive" ? "Inactif" : "Actif";
        updated_at = data && data?.updated_at ? data.updated_at : "N/A";
        startDate = data && data?.start_date ? data.start_date : "-";
        endDate = data && data?.end_date ? data.end_date : "-";
        triggerName = data && data?.trigger_name ? data.trigger_name : "-";
        clientTypes = data && data?.client_types ? data.client_types : [];
    }

    if (templates.data && templates.data !== undefined && 'templates' in templates.data) {

        templateName = templates.data.templates[0].name;
    }

    if (documents.data && documents.data !== undefined && 'documents' in documents.data) {

        documentsName = documents.data.documents.map((document: any) => {
            return document.name
        });
    }

    if (products.data && products.data !== undefined && 'products' in products.data) {

        productsName = products.data.products.map((product: any) => {
            return product.reference
        });
    }

    const handleSendTestEmail = useCallback(async () => {
            if (!uuid) {
                return;
            }
            setIsTestButtonDisabled(true);
            try {
                const response = (await postTestMaillingRule({ uuid: uuid }).unwrap()).message;
    
                setPostTestMaillingRuleResponseMessage(response);
                setShowAlert(true);
                setTimeout(() => setShowAlert(false), 5000);    
            } catch (error) {
                setPostTestMaillingRuleResponseMessage('Une erreur est survenue lors du renvoi de l\'email');
                setShowAlert(true);
                setTimeout(() => setShowAlert(false), 5000);
            }
            setIsTestButtonDisabled(false);
        }, [postTestMaillingRule, setPostTestMaillingRuleResponseMessage, setShowAlert, uuid]);

    return (

        <>
            {(isLoading || isFetching) && <p>Chargement...</p>}

            {((!isLoading && !isFetching) && data !== undefined && 'uuid' in data) && (
                <>
                    <div className="object mailing" data-status="active">
                        <header>
                            <h2>{data.name}</h2>
                            <div className="object-date" title={`Dernière mise-à-jour le : ${updated_at}`}>
                                <span className="icon"></span>
                                <span className="text">{updated_at}</span>
                            </div>
                            <div className="object-status" title="Statut : Actif">
                                <span className="icon"></span>
                                <span className="text">{status}</span>
                            </div>
                            <div className="object-actions">
                                <Button 
                                    type="button" 
                                    variant="none" 
                                    className="btn-sendEmailTest" 
                                    data-bs-toggle="modal" 
                                    data-bs-target="#mailingSendTestModal" 
                                    title="Envoyer un email de test"
                                    onClick={()=>{handleSendTestEmail()}}
                                    {
                                        ...(isTestButtonDisabled ? {disabled: true} : {})
                                    }
                                    >
                                    <span className="icon"></span>
                                    <span className="text">Email Test</span>
                                </Button>
                                <NavLink to={`/mailing-rules/${uuid}/edit`} className="btn btn-edit" title="Modifier la Configuration d'envoi">
                                    <span className="icon"></span>
                                    <span className="text">Modifier</span>
                                </NavLink>
                            </div>                           
                        </header> 
                            {showAlert && postTestMaillingRuleResponseMessage && (
                                <Alert variant="success" onClose={() => setShowAlert(false)} dismissible>
                                    {postTestMaillingRuleResponseMessage}
                                </Alert>
                            )}
                        <section className="schedule">
                            <h3>
                                <span className="icon"></span>
                                <span className="test">Programmation</span>
                            </h3>
                            <ul className="dl">
                                <li>
                                    <div className="dt">Du</div>
                                    <div className="dd">{startDate}</div>
                                </li>
                                <li>
                                    <div className="dt">Au</div>
                                    <div className="dd">{endDate}</div>
                                </li>
                            </ul>
                        </section>
                        <section className="trigger">
                            <h3>
                                <span className="icon"></span>
                                <span className="test">Déclencheur</span>
                            </h3>
                            <ul className="dl">
                                <li>
                                    <div className="dt">Client(s) cible</div>
                                    <div className="dd">
                                        {clientTypes.map((clientType: IClientType) => clientType.name).join(", ")}
                                    </div>
                                </li>
                                <li>
                                    <div className="dt">Déclencheur</div>
                                    <div className="dd">{triggerName}</div>
                                </li>
                                <li>
                                    <div className="dt">Critères du déclencheur</div>
                                    <div className="dd">
                                        <ul>
                                            {productsName.length === 0 ? (
                                                <li>Aucun critère de déclencheur configuré.</li>
                                            ) : (
                                                productsName.map((document: any) => {
                                                    return <li key={document}>{document}</li>;
                                                })
                                            )}
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </section>
                        <section className="email">
                            <h3>
                                <span className="icon"></span>
                                <span className="test">Email</span>
                            </h3>
                            <ul className="dl">
                                <li>
                                    <div className="dt">Template email</div>
                                    <div className="dd">{templateName}</div>
                                </li>
                                <li>
                                    <div className="dt">Pièces jointes</div>
                                    <div className="dd">
                                        <ul>
                                            {documentsName.length === 0 ? (
                                                <li>Aucun document disponible.</li>
                                            ) : (
                                                documentsName.map((document: any) => {
                                                    return <li key={document}>{document}</li>;
                                                })
                                            )}
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </section>
                        <NavLink to="/mailing-rules" className="btn btn-secondary btn-back" title="">
                            <span className="icon"></span>
                            <span className="text">Retour</span>
                        </NavLink>
                    </div>
                </>
            )
            }

            {
                ((!isLoading && !isFetching) && data === undefined) &&
                <p>Une erreur a été rencontrée.</p>
            }
        </>
    );
}